// extracted by mini-css-extract-plugin
export default {"beParts":"BeParts_beParts__GLBnd","bePartsInner":"BeParts_bePartsInner__nl70v"};